import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

// 第8期は自社プロダクトのリリース。品質・調整・配信の各トラックは局所的にだけ交わる。
export const MAP_NODES_PRODUCT_RELEASE: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["r-quality", "r-coordination", "r-delivery"], x: 2, y: 0 }),

  "r-quality": caseNode("r-quality", ["r-quality-2"], 0, 2),
  "r-quality-2": caseNode("r-quality-2", ["event-r-quality"], 0, 4),
  "event-r-quality": eventNode("event-r-quality", ["r-quality-3"], 0, 5),
  "r-quality-3": caseNode("r-quality-3", ["rest-r-quality", "r-handoff", "event-r-quality-late"], 1, 7),
  "rest-r-quality": restNode("rest-r-quality", ["r-pre-quality"], 1, 8),
  "r-handoff": caseNode("r-handoff", ["r-pre-delivery"], 2, 8),
  "event-r-quality-late": eventNode("event-r-quality-late", ["r-pre-quality"], 0, 8),

  "r-coordination": caseNode("r-coordination", ["r-coordination-left", "r-coordination-right"], 2, 2),
  "r-coordination-left": caseNode("r-coordination-left", ["event-r-policy", "r-review"], 1, 5),
  "event-r-policy": eventNode("event-r-policy", ["r-quality-3"], 1, 6),
  "r-review": caseNode("r-review", ["r-quality-3"], 2, 6),
  "r-coordination-right": caseNode("r-coordination-right", ["r-delivery-3"], 3, 5),

  "r-delivery": caseNode("r-delivery", ["rest-r-delivery-open"], 4, 2),
  "rest-r-delivery-open": restNode("rest-r-delivery-open", ["r-delivery-2"], 4, 3),
  "r-delivery-2": caseNode("r-delivery-2", ["r-delivery-3"], 4, 4),
  "r-delivery-3": caseNode("r-delivery-3", ["r-release-window"], 3, 6),
  "r-release-window": caseNode("r-release-window", ["r-priority-fix", "rest-r-delivery"], 3, 8),
  "r-priority-fix": caseNode("r-priority-fix", ["r-pre-delivery"], 3, 10),
  "rest-r-delivery": restNode("rest-r-delivery", ["r-pre-delivery"], 4, 9),

  "r-pre-quality": caseNode("r-pre-quality", ["r-release-candidate"], 1, 10),
  "r-pre-delivery": caseNode("r-pre-delivery", ["r-release-decision"], 3, 11),
  "r-release-candidate": caseNode("r-release-candidate", ["r-final-audit", "r-final-fix"], 1, 12),
  "r-release-decision": caseNode("r-release-decision", ["r-staged-release", "r-launch-comms"], 3, 12),
  "r-final-audit": caseNode("r-final-audit", ["r-quality-signoff"], 0, 13),
  "r-final-fix": caseNode("r-final-fix", ["r-quality-signoff"], 2, 13),
  "r-staged-release": caseNode("r-staged-release", ["r-delivery-signoff"], 3, 14),
  "r-launch-comms": caseNode("r-launch-comms", ["r-delivery-signoff"], 4, 14),
  "r-quality-signoff": caseNode("r-quality-signoff", ["rest-r-pre"], 1, 15),
  "r-delivery-signoff": caseNode("r-delivery-signoff", ["rest-r-pre"], 3, 16),
  "rest-r-pre": restNode("rest-r-pre", ["boss"], 2, 18),
  boss: node("boss", { kind: "case", caseId: "product-release-boss", next: [], x: 2, y: 19 }),
};
